import React from 'react'
import  ReactDOM  from "react-dom";
import Router from './routers/Router'

import './index.css'

ReactDOM.render(<Router/>, document.querySelector('#app'))
